export const FETCH_ALL_FORMS = 'FETCH_ALL_FORMS';
export const GET_FORM = 'GET_FORM';
export const CREATE_FORM = 'CREATE_FORM';
export const GET_FIELD_OBJECTS = 'GET_FIELD_OBJECTS';
export const GET_FIELD_OBJS_BY_PAGE = 'GET_FIELD_OBJS_BY_PAGE';